import { useEffect, useState } from "react"

import { isWeb } from "shared/lib/runtimeEnvironment"

export const DESKTOP_SIZE = "(min-width: 993px)"
export const TABLET_SIZE = "(max-width: 992px)"
export const MOBILE_SIZE = "(max-width: 576px)"
export const MOBILE_SMALL_SIZE = "(max-width: 420px)"

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    if (isWeb()) {
      const media = window.matchMedia(query)
      if (media.matches !== matches) {
        setMatches(media.matches)
      }
      const listener = () => setMatches(window.matchMedia(query).matches)
      window.addEventListener("resize", listener)
      return () => window.removeEventListener("resize", listener)
    }
    return undefined
  }, [query])

  return matches
}
